import { getApiUrl } from "../config";
import http from "./httpService";

const apiEndpoint = getApiUrl() + "/projetos";

function projetoUrl(id) {
  return `${apiEndpoint}/${id}`;
}

function getProjetos(): Promise<{ data: Projeto[] }> {
  return http.get(apiEndpoint);
}

function getProjeto(projetoId) {
  return http.get(projetoUrl(projetoId));
}

function saveProjeto(projeto) {
  if (projeto.projetoId) {
    const body = { ...projeto };
    delete body.projetoId;
    return http.put(projetoUrl(projeto.projetoId), body);
  }
  return http.post(apiEndpoint, projeto);
}

function deleteProjeto(projetoId) {
  return http.delete(projetoUrl(projetoId));
}

const exportObject = {
  getProjetos,
  getProjeto,
  saveProjeto,
  deleteProjeto,
};

export default exportObject;
